const ID = 'transcription';

export default ID;
